export const otherSiteColor = '#6b6b6a';
export const clubSiteColor = '#074391';
export const forestSiteColor = '#77a936';
export const certificatedSiteColor = '#8a488a';
export const europeanSiteColor = '#e66832';
export const listedSiteColor = '#e8cb2c';
export const nonSiteColor = '#d04247';
export const regionSiteColor = '#d04247';
export const readyCampColor = '#00a3ff';

export const otherSiteType = 'Other';
export const clubSiteType = 'ClubSite';
export const forestSiteType = 'CampingInTheForestSite';
export const certificatedSiteType = 'CertificatedSite';
export const europeanSiteType = 'EuropeanTravelSite';
export const listedSiteType = 'ListedSite';
export const readyCampType = 'ReadyCamp';

export const CAMPSITE_TYPES = {
  OTHER: {
    color: otherSiteColor,
    cssModifier: 'other',
    id: 0,
  },
  CLUB_SITE: {
    color: clubSiteColor,
    cssModifier: 'club',
    id: 1,
  },
  FOREST_SITE: {
    color: forestSiteColor,
    cssModifier: 'forest',
    id: 2,
  },
  CERTIFICATED_SITE: {
    color: certificatedSiteColor,
    cssModifier: 'certificated',
    id: 3,
  },
  EUROPEAN_SITE: {
    color: europeanSiteColor,
    cssModifier: 'european',
    id: 4,
  },
  LISTED_SITE: {
    color: listedSiteColor,
    cssModifier: 'listed',
    id: 5,
  },
  READY_CAMP_SITE: {
    color: readyCampColor,
    cssModifier: 'readyCamp',
    id: 6,
  },
};
